import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../services/api';
import { useQuery } from '@tanstack/react-query';
import { useGetVendor } from '../vendors/Vendors';

export const useGetUser = () => {
    const user = localStorage.getItem('user');
    if (user)
        return JSON.parse(localStorage.getItem('user'));
    else
        return false
}

export const useGetUserAdmin = () => {
    const admin = localStorage.getItem('admin');
    if (admin)
        return JSON.parse(localStorage.getItem('admin'));
    else
        return false
}


export const useGetCurrentVendor = () => {
    const vendor = JSON.parse(localStorage.getItem('vendor'));
    const vendorId = useGetVendorId();

    if (vendor || vendorId===vendor?.id)
        return JSON.parse(localStorage.getItem('vendor'));
    else
        return false;
}


/*export const useGetVendorId = () => {
    const { vendorId: vendorIdFromUrl } = useParams();

    return localStorage.getItem('vendorId');
};*/

export const useGetVendorId = () => {
    const { vendorId: vendorIdFromUrl } = useParams();
    const [vendorId, setVendorId] = useState(localStorage.getItem('vendorId'));

    // Sync with vendorIdFromUrl
    useEffect(() => {
        if (vendorIdFromUrl) {
            localStorage.setItem('vendorId', vendorIdFromUrl);
            setVendorId(vendorIdFromUrl);  // Update state to trigger re-render
        }
    }, [vendorIdFromUrl]);

    // Listen for changes to localStorage from other tabs/windows
    useEffect(() => {
        const handleStorageChange = (event) => {
            if (event.key === 'vendorId') {
                setVendorId(event.newValue);
            }
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    return vendorId ?  vendorId:vendorIdFromUrl;
};

export const useGeVendortUsers = () => {
    const vendorId = useGetVendorId()
    const fetchData = async () => {
        const { data } = await api.get(`/users/vendor/${vendorId}?vendorId=${vendorId}`)
        return data;
    };
    return useQuery({ queryKey: ['users'], queryFn: fetchData, enabled: true });
};



